import { getEscapedTranslations } from './getEscapedTranslations';
import { ISO6391LanguageCode } from './types';

export const englishTranslations = getEscapedTranslations(
    ISO6391LanguageCode.en,
);
